// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown-menu.limited-height[data-v-f15c3702]{max-height:250px;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
